import type {PaletteMode} from '@mui/material';
import createTheme from '@mui/material/styles/createTheme';
import {lighten} from '@mui/system/colorManipulator';

export const primaryColor = '#661e8a';
export const secondaryColor = '#ffe55d';

export const BORDER_RADIUS = 0;

const theme = (mode?: PaletteMode) =>
  createTheme({
    palette: {
      mode: mode ?? 'light',
      primary: {
        main: primaryColor,
        contrastText: '#fff',
        gradient: 'linear-gradient(45deg, #0B1B34, #E62E83)',
      },
      secondary: {
        main: secondaryColor,
      },
      text: {
        primary: '#000000',
        secondary: '#746F81',
      },
      background: {
        semiTransparent: 'rgba(255, 255, 255, 0.65)',
      },
    },
    shape: {
      borderRadius: BORDER_RADIUS,
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: BORDER_RADIUS,
            height: '42px',
          },
        },
      },
      MuiCssBaseline: {
        styleOverrides: {
          /* Firefox Scrollbar */
          body: {
            scrollbarColor: `${lighten(primaryColor, 0.5)} transparent` /* scroll thumb and track */,
            scrollbarWidth: '2px',
          },
          /* Chrome Scrollbar */
          '*::-webkit-scrollbar': {
            width: '0.2em',
            height: '0.15em',
          },
          '*::-webkit-scrollbar-track': {
            WebkitBoxShadow: 'inset 0 0 2px rgba(0,0,0,0.00)',
          },
          '*::-webkit-scrollbar-thumb': {
            backgroundColor: lighten(primaryColor, 0.5),
            opacity: 0.2,
            outline: '0px solid slategrey',
          },
        },
      },
    },
  });

export default theme;
